<ng-container
  *ngIf="
    filteredMatchExclusions.accountExclusions.length ||
      filteredMatchExclusions.segmentExclusions.length;
    else noExclusionsTemplate
  "
>
  <ng-container *ngIf="filteredMatchExclusions.segmentExclusions.length">
    <p class="u-marginBottom-8" i18n="@@accountEditDrawer.excludedMatches">
      Excluded roles/segments
    </p>
    <div fxLayout="row wrap" fxLayoutGap="8px">
      <ng-container
        *ngFor="let exclusion of filteredMatchExclusions.segmentExclusions"
      >
        <ng-container
          [ngTemplateOutlet]="exclusionChip"
          [ngTemplateOutletContext]="{ name: exclusion.exclude_string }"
        >
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
  <ng-container *ngIf="filteredMatchExclusions.accountExclusions.length">
    <p class="u-marginBottom-8" i18n="@@accountEditDrawer.excludedAccounts">
      Excluded accounts
    </p>
    <div fxLayout="row wrap" fxLayoutGap="8px">
      <ng-container
        *ngFor="let exclusion of filteredMatchExclusions.accountExclusions"
      >
        <ng-container
          [ngTemplateOutlet]="exclusionChip"
          [ngTemplateOutletContext]="{ name: exclusion.exclude_string }"
        >
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
<ng-template #noExclusionsTemplate>
  <p class="color-grey-300" i18n="@@accountEditDrawer.noExclusions">
    No match exclusions selected.
  </p>
</ng-template>
<ng-template #exclusionChip let-name="name">
  <div
    class="u-border-grey100 u-borderRadius--4px text-caption u-marginBottom-8"
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="4px"
    [ngStyle]="{ padding: '4px 8px' }"
  >
    <mat-icon class="md-18 color-orange">highlight_off</mat-icon>
    <span [ngStyle]="{ maxWidth: '200px' }" class="u-textTruncate">{{
      name | translationLookup: ['@@groupRole', '@@groupCustomSegmentOption']
    }}</span>
  </div>
</ng-template>
